import { render } from "./Stage.vue?vue&type=template&id=7774711a&scoped=true"
import script from "./Stage.vue?vue&type=script&lang=js"
export * from "./Stage.vue?vue&type=script&lang=js"

import "./Stage.vue?vue&type=style&index=0&id=7774711a&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-7774711a"

export default script